import { IClassname } from '@/lib/shared/model/classname';

export const Cleaning = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.30396 25.9038V20.7922C1.30396 20.1144 1.57323 19.4643 2.05255 18.9849C2.53185 18.5056 3.18194 18.2363 3.85979 18.2363H8.97146C11.3439 18.2363 13.6192 19.1788 15.2968 20.8564C16.9744 22.534 17.9169 24.8093 17.9169 27.1817C17.9169 27.8596 17.6476 28.5096 17.1683 28.989C16.6889 29.4683 16.0388 29.7376 15.361 29.7376H5.1377"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1377 29.7378C7.25502 29.7378 8.97146 28.0214 8.97146 25.9041C8.97146 23.7867 7.25502 22.0703 5.1377 22.0703C3.02039 22.0703 1.30396 23.7867 1.30396 25.9041C1.30396 28.0214 3.02039 29.7378 5.1377 29.7378Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.124 19.8686C15.2161 18.2419 15.8629 16.3573 16 14.4029C15.8591 12.1969 15.3745 10.0264 14.5636 7.96987C14.329 7.32777 14.2528 6.63854 14.3415 5.96069C14.4302 5.28285 14.6811 4.63641 15.0729 4.07624C15.4648 3.51606 15.9859 3.05871 16.5923 2.74299C17.1987 2.42727 17.8723 2.26252 18.5558 2.2627C19.7421 2.2627 20.8797 2.73393 21.7186 3.57273C22.5574 4.41151 23.0285 5.54917 23.0285 6.7354V25.9042"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6961 29.738H24.3065C23.9676 29.738 23.6425 29.6034 23.4029 29.3637C23.1633 29.1241 23.0286 28.799 23.0286 28.4601V25.9043H26.8623C27.879 25.9043 28.8542 26.3082 29.5732 27.0272C30.2921 27.7462 30.6961 28.7213 30.6961 29.738Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2494 18.3252C9.82083 19.1032 9.60237 19.9795 9.61555 20.8675C9.62874 21.7556 9.8731 22.625 10.3246 23.3898C10.776 24.1548 11.419 24.7888 12.1901 25.2295C12.9612 25.6703 13.8339 25.9025 14.7221 25.9032H17.8262"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.13759 26.2229C4.96115 26.2229 4.81812 26.0799 4.81812 25.9035C4.81812 25.727 4.96115 25.584 5.13759 25.584"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M5.1377 26.2229C5.31414 26.2229 5.45717 26.0799 5.45717 25.9035C5.45717 25.727 5.31414 25.584 5.1377 25.584"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
